import React from "react";
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";
import Blog from "../components/Route/Blog";
import Helmet from "../components/Helmet/Helmet";

const BlogPage = () => {
  return (
    <>
      <Helmet title={"Blog"}>
        <Header activeHeading={6} />
        <Blog />
        <Footer />
      </Helmet>
    </>
  );
};

export default BlogPage;
